<script setup lang="ts">
import type { Content } from "@prismicio/client";

defineProps(getSliceComponentProps<Content.FeatureHighlightsSlice>());

const cardColors = ['pa-fh__card--primary', 'pa-fh__card--dark', 'pa-fh__card--secondary']
</script>

<template>
  <section
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      class="pa-fh"
  >
    <div class="pa-container">
      <div v-if="slice.primary.section_heading" class="pa-fh__heading">
        <PrismicRichText :field="slice.primary.section_heading" />
      </div>

      <div class="pa-fh__grid">
        <div
            v-for="(feature, index) in slice.primary.features"
            :key="index"
            :class="['pa-fh__card', cardColors[index % cardColors.length]]"
        >
          <div v-if="feature.icon?.url" class="pa-fh__card-icon">
            <PrismicImage :field="feature.icon" />
          </div>
          <h3 class="pa-fh__card-title">{{ feature.title }}</h3>
          <div class="pa-fh__card-description">
            <PrismicRichText :field="feature.description" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
